import { authHeader, handleResponse } from '../helpers'

export const taskService = {
    getTasks,
    getTasksConfirmed,
    getTasksByDateRange,
    getTask,
    createTask,
    editTask,
    deleteTask,
    loadCertificate,
};

function getTasks(confirmed) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    const params = confirmed ? '?confirmed=1' : '';
    return fetch(process.env.VUE_APP_API_URL + `/task${params}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getTasksConfirmed(invoiced) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    const params = invoiced ? '?invoiced=1' : '';
    return fetch(process.env.VUE_APP_API_URL + `/task/confirmed${params}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getTasksByDateRange(startDate, endDate) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/task/${startDate}/${endDate}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getTask(taskId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/task/${taskId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function createTask(taskData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: taskData
    };
    return fetch(process.env.VUE_APP_API_URL + `/task`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function editTask(taskId, taskData) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: taskData
    };
    return fetch(process.env.VUE_APP_API_URL + `/task/${taskId}`, requestOptions)
    .then(response => {
        return response;
    });
}

function deleteTask(taskId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_API_URL + `/task/${taskId}`, requestOptions)
    .then(response => response.text())
    .then(response => {
        return response;
    });
}

function loadCertificate(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: data,
        responseType: "blob"
    };
    return fetch(process.env.VUE_APP_API_URL + '/task/certificate', requestOptions)
      .then(response => response.blob())
      .then(blobTxt => {

            var blob = new Blob([blobTxt], {type: "application/pdf"});
            var win = window.open('', '_blank');
            var URL = window.URL || window.webkitURL;
            var dataUrl = URL.createObjectURL(blob);
            win.location = dataUrl;

            return true;
      });
}
